import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo } from "react";
import { useDidomiConsents, useUserCentricsConsents } from "./hooks";
import { useBrandContext } from "@/shared/contexts";
export const GDPRContext = createContext(null);
export const GDPRProvider = ({ children }) => {
    const { cmp: { type: GDPRType }, } = useBrandContext();
    const { didomiPurposesConsent, isDidomiReady, didomiConsentHasChanged } = useDidomiConsents();
    const { UCPurposesConsent, isUcReady, UCConsentHasChanged } = useUserCentricsConsents();
    const contextValue = useMemo(() => ({
        purposesConsent: GDPRType === "didomi" ? didomiPurposesConsent : UCPurposesConsent,
        isGDPRReady: GDPRType === "didomi" ? isDidomiReady : isUcReady,
        consentHasChanged: GDPRType === "didomi" ? didomiConsentHasChanged : UCConsentHasChanged,
    }), [
        didomiPurposesConsent,
        UCPurposesConsent,
        GDPRType,
        isDidomiReady,
        isUcReady,
        didomiConsentHasChanged,
        UCConsentHasChanged,
    ]);
    return (_jsx(GDPRContext.Provider, { value: contextValue, children: children }));
};
